<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <span class="title-chart">Proporsi Status Pendaftaran</span>
    </div>

    <div class="chart-container">
      <a-spin :spinning="loading">
        <div v-if="!hasRenderableData" class="empty-state">
          <p>Tidak ada data tersedia</p>
        </div>
        <apexchart v-else type="donut" height="250" :options="chartOptions" :series="chartSeries" />
      </a-spin>

      <div v-if="hasRenderableData" class="legend-wrapper mt-5">
        <div class="legend-row" v-for="(item, idx) in legendData" :key="idx">
          <span class="legend-dot" :style="{ borderColor: chartColors[idx] }"></span>
          <span class="legend-label">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted } from 'vue'
import apiClient from '@/services/axios/perki'

export default {
  name: 'ProporsiStatusPendaftaran',
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const loading = ref(false)

    const apiData = ref(null)

    const chartColors = ['#E10F28', '#C34F6B', '#2F318B', '#8688CA']

    const statusPendaftaran = computed(() => {
      if (!apiData.value) return []

      // Preferred shape: { statusPendaftaran: [...] }
      if (Array.isArray(apiData.value.statusPendaftaran)) {
        return apiData.value.statusPendaftaran
      }

      return []
    })

    const chartSeries = computed(() => {
      if (statusPendaftaran.value.length > 0) {
        return statusPendaftaran.value.map(item => item.count || 0)
      }
      return []
    })

    const hasRenderableData = computed(() => chartSeries.value.some(value => value > 0))

    const legendData = computed(() => {
      if (statusPendaftaran.value.length > 0) {
        return statusPendaftaran.value.map(item => ({
          label: item.status,
          value: item.count || 0,
          percentage: item.percentage || 0,
        }))
      }
      return [
        { label: 'Diterima', value: 70, percentage: 70 },
        { label: 'Selesai Disposisi', value: 30, percentage: 30 },
      ]
    })

    const chartOptions = computed(() => ({
      chart: {
        type: 'donut',
      },
      colors: chartColors,
      labels: legendData.value.map(item => item.label),
      dataLabels: { enabled: false },
      plotOptions: {
        pie: {
          donut: {
            size: '70%',
            labels: {
              show: false,
            },
          },
        },
      },
      legend: { show: false },
      stroke: {
        width: 0,
      },
    }))

    watch(
      () => props.data,
      value => {
        if (value) {
          apiData.value = value
        }
      },
      { immediate: true, deep: true },
    )

    return {
      loading,
      chartSeries,
      chartOptions,
      legendData,
      chartColors,
      hasRenderableData,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../style.scss';

.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-chart {
  font-size: 16px;
  font-weight: 700;
  color: $primary;
}

.legend-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 60%;
  text-align: center;

  @media (max-width: 620px) {
    max-width: 80%;
  }

  @media (max-width: 475px) {
    max-width: 100%;
  }
}

.legend-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.legend-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: white;
  border-style: solid;
  border-width: 5px;
  box-sizing: border-box;
}

.legend-label {
  flex: 1;
  font-size: 14px;
  color: #667085;
}

.legend-value {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}

:deep(.ant-tabs-ink-bar) {
  background-color: #e10f28 !important;
}

:deep(.ant-tabs-nav .ant-tabs-tab) {
  margin: 0 36px 0 0 !important;
  font-weight: 400 !important;
}

:deep(.ant-tabs-nav .ant-tabs-tab-active) {
  color: #e10f28 !important;
}

:deep(.ant-tabs-nav .ant-tabs-tab:hover) {
  color: #e10f28 !important;
}
</style>
